// NOTE: https://qiita.com/saba_can00/items/bdefb28a1873658cf5d9
export const PANEL = {
  memberEntry: 1,
  mailAddressConfirm: 2,
  contactForm: 3,
} as const;

type TypeOfPanel = typeof PANEL;
export type TAppPanel = TypeOfPanel[keyof TypeOfPanel];
